import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

import { ModalComponent } from '../../../../config/core.modal-helpers';
import { ProjectService } from '../../../../services/project.service';
import { ProjectSprintData } from '../../services/project.sprint.data.service';
import { UiService } from '../../../../services/core.ui.service';
import { GfTranslateService } from '../../../../services/core.translate.service';

import * as _ from 'lodash';

@Component({
	selector: 'project-sprint-edit',
	template: require('./project.sprint.edit.html')
})
export class ProjectSprintEditComponent extends ModalComponent implements OnInit, OnChanges {

	@Input() sprint: any = null;
	@Input() project: any = null;

	@Input() legacyCallback: any = null;

	@Output() callback = new EventEmitter<any>();

	protected sprintUpdate: any = null;

	protected projectSprintData: any = {
		getTitle: (sprint) => {
			if (!sprint) return '';

			if (!_.isEmpty(_.get(sprint, 'sprintName', ''))) {
				return sprint.sprintName;
			}

			return this.gfTranslateService.translate('Sprint') + ' ' + _.get(sprint, 'sprintProgression', 1);
		},
		getSprintLabelText: (status) => {
			switch (status) {
				case 1:
					return this.gfTranslateService.translate('In Progress');
				case 2:
					return this.gfTranslateService.translate('Completed');
				default:  // includes 0 = not started
					return this.gfTranslateService.translate('Not Started');
			}
		}
	};

	constructor(
		private projectService: ProjectService,
		private uiService: UiService,
		private gfTranslateService: GfTranslateService,
	) {
		super();
	}

	ngOnInit() {
		if (this.sprint) {
			this.sprintUpdate = _.cloneDeep(this.sprint);
		}
	};

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.sprint && !changes.sprint.isFirstChange()) {
			this.sprintUpdate = _.cloneDeep(this.sprint);
		}
	}

	saveSprint() {
		var ret = false;
		this.sprintUpdate.project = this.project.id;
		this.projectService.updateSprint(this.sprintUpdate)
		.then(() => {
			this.uiService.message.showSuccess(this.gfTranslateService.translate('The sprint has been succesfuly updated.'), 'Sprint updated');
			ret = true;
		})
		.catch(() => {
			var msg =  this.gfTranslateService.translate('There was a problem updating the sprint');
			this.uiService.message.showWarning(msg, 'Data Error');
		})
		.finally(() => {
			this.legacyCallback && this.legacyCallback(this.sprint, ret);
			this.callback.emit(this.sprint);
			this.closeModal();
		});
	};

	cancelEdit() {
		this.closeModal();
	}

	onSprintStartDateUpdate($event) {
		this.sprintUpdate.sprintStart = $event;
	}

	onSprintEndDateUpdate($event) {
		this.sprintUpdate.sprintEnd = $event;
	}
}